/**
 * NCMS 공통 토스트 팝업 — chat.toast postMessage 전송.
 *
 * 위젯(iframe)은 토스트 DOM 을 직접 렌더링하지 않는다.
 * 복사 성공 시 BRFrame chat 에 ``chat.toast`` 메시지를 전송하면,
 * 챗창이 하단에 ``toast-popup full`` (NCMS 동일 클래스) 을 2초간 표시한다.
 */

import { useCallback } from "react";
import { copyTextToClipboard } from "./clipboard";
import { postToastMessage } from "./postmessage";

const _SKU_COPY_MSG = "The model name code has been copied";
const _COUPON_COPY_MSG = "The coupon code has been copied";

/** SKU 복사 → chat.toast postMessage (모든 제품 카드 공통). */
export function useSkuCopyToast() {
  const copySku = useCallback((sku: string) => {
    if (!sku) return;
    void copyTextToClipboard(sku).then((ok) => {
      if (!ok) return;
      postToastMessage(_SKU_COPY_MSG);
    });
  }, []);

  return { copySku };
}

/** 쿠폰코드 복사 → chat.toast postMessage. */
export function useCouponCopyToast() {
  const copyCode = useCallback((code: string) => {
    if (!code) return;
    void copyTextToClipboard(code).then((ok) => {
      if (!ok) return;
      postToastMessage(_COUPON_COPY_MSG);
    });
  }, []);

  return { copyCode };
}
